/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 12/1/20
 * Time: 7:09 PM
 */
import React, {Component} from 'react';
import {Button as SementicBtn, Menu, Sidebar,} from 'semantic-ui-react';
import './RightSideDrawer.scss';
import {Col, Row} from "reactstrap";
import Webcam from "react-webcam";
import CaptureVisitor from "./CaptureVisitor/CaptureVisitor";
import $ from "jquery";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../assets/img/sweet/question.svg";
import * as common from "../../../../const/Common/CommonFunc";
import * as actionCreator from "../../../../store/Action";
import {connect} from "react-redux";
import axios from "../../../../axios/axios_visitortag";
import apiConfig from "../../../../axios/axios_api_services";
import Cookies from "js-cookie";
import {Tooltip} from "antd";
import {withTranslation} from "react-i18next";

class App extends Component {
  state = {
    tempList: [],
    facingFront:true
  };
  visitorImageMouseHover = (img) => {
    $("#hover-fr-img").attr("src", img);
    $(".cp-visitor-hover-image").css("display","flex");
  };
  visitorImageMouseOut = () => {
    $(".cp-visitor-hover-image").css("display","none");
  };
  commonFunc = name => (obj) => {
    // console.log(`${name}:`,obj);
  };
  caputureImageHandler = () => {
    let screenshot = this.refs.webcam.getScreenshot();
    this.recognizeUserByImageHandler(screenshot);
  };

  recognizeUserByImageHandler = (screenshot) => {
    this.props.spinnerHandler(true);
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    let corporateId = this.props.usr_obj.corporates[0].corporateId;
    axios.post(apiConfig.IVCA_RECOGNIZE_USER_BY_IMAGE(corporateId), {image: screenshot}, {headers: headers})
      .then(response => {
        if (response.data.success) {
          let results = response.data.visitors;
          if (results.length > 1) {
            this.setState({tempList: results})
          } else if (results.length > 0) {
            this.selectVisitorHandler(results[0]);
          }
          return;
        }
        common.warningAlert(response.data.message, 1)
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.recognizeUserByImageHandler(screenshot)
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      })
  };

  clearVisitorFromCurrentQueue = (obj) => {
    let idArray = [];
    if (obj) {
      idArray = obj.error_code === 710 ? [obj.visitor.visitor.userId] : [obj.visitor.userId];
    } else {
      let {visitorList} = this.props;
      visitorList.map((obj, index) => {
        idArray.push(obj.error_code === 710 ? obj.visitor.visitor.userId : obj.visitor.userId);
      })
    }

    swal({
      title: obj ? "Do you wish to remove a visitor from the current queue?" : "Do you wish to remove all visitors from the current queue?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {cancel: 'Cancel', dangerMode: {text: "Yes", value: "action", className: "okay-btn"}},
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.props.socketDeleteIdListHandler(idArray);
            break;
          default:
        }
      });
  };
  selectVisitorHandler = (obj, status) => {
    this.props.closeDrawer("visibleRightDrawer", false);
    if (obj.error_code === 710) {
      this.props.finalizeVisitorDetails(obj);
    } else {
      this.props.finalizeVisitorDetails({visitorList: [obj]});
    }
    if (status === 0) this.setState({tempList: []});
  };

  handleFacingMode = () => {
    this.setState({facingFront: !this.state.facingFront})
  }

  render() {
    let {visibleDrawer, visitorList} = this.props;
    let {tempList, facingFront} = this.state;
    let body = $('body');
    visibleDrawer ? body.addClass("modal-open") : body.removeClass("modal-open");
    const {t} = this.props;
    return (
      <div className={"right-side-drawer-custom"}>
        <Sidebar
          as={Menu}
          animation='overlay'
          direction='right'
          icon='labeled'
          className={"reception-right-side-drawer "}
          inverted
          vertical
          visible={visibleDrawer}
          width='thin'
        >
          <Row>
            {visibleDrawer ? <Col xs={12} className={"cp-capture-layout "}>
              <Webcam
                forceScreenshotSourceSize={true}
                mirrored={true}
                imageSmoothing={true}
                screenshotQuality={100}
                onUserMediaError={this.commonFunc('onUserMediaError')}
                onUserMedia={this.commonFunc('onUserMedia')}
                videoConstraints={{facingMode: facingFront ? "user" : { exact: "environment" }}}
                style={{width: '100%'}}
                audio={false}
                screenshotFormat={"image/jpeg"}
                ref='webcam'
              />
              <Row>
                <Col className={"align-center"} style={{ marginTop: "2vh" }}>
                  <SementicBtn style={{ width: "220px",fontSize: '12px' }} className="px-5 search-visitor-btn"
                               onClick={this.caputureImageHandler} >{t('capture_and_search')}</SementicBtn>
                  <SementicBtn style={{ height:'100%', marginLeft:'10px' }} icon='sync'
                               onClick={this.handleFacingMode}
                  />
                </Col>
              </Row>
            </Col> : null}
            {
              tempList && tempList.length !== 0 &&
              <Col xs={12} className={"cp-visitor-main-wrapper"}>
                <p className={"small-text"}>{`Found ${tempList.length} visitors for this image.`}</p>
                <div>
                  {tempList.map((obj, index) => (
                    <CaptureVisitor {...obj} index={index} hideRemoveBtn={true} key={index}
                                    selectVisitorHandler={() => this.selectVisitorHandler(obj, 0)}
                                    visitorImageMouseHover={this.visitorImageMouseHover}
                                    visitorImageMouseOut={this.visitorImageMouseOut}
                                    removeVisitor={() => this.clearVisitorFromCurrentQueue(obj)}/>
                  ))}
                </div>
              </Col>
            }
            {
              visitorList && visitorList.length !== 0 &&
              <Col xs={12} className={"cp-visitor-main-wrapper"}>
                <p
                  className={"small-text"}>{`${visitorList.length} ${visitorList.length === 1 ? `visitor was` : `visitors were`} captured by CCTV cameras.`}
                  {visitorList.length > 1 && <Tooltip placement="topLeft" title={t('remove_all_visitors')}><label
                    onClick={() => this.clearVisitorFromCurrentQueue(null)} className={"cp-remove-all-visitors"}>{t('remove_all')}</label></Tooltip>}</p>
                <div>
                  {visitorList.map((obj, index) => (
                    <CaptureVisitor {...obj} index={index} key={index}
                                    selectVisitorHandler={() => this.selectVisitorHandler(obj)}
                                    visitorImageMouseHover={this.visitorImageMouseHover}
                                    visitorImageMouseOut={this.visitorImageMouseOut}
                                    removeVisitor={() => this.clearVisitorFromCurrentQueue(obj)}/>
                  ))}
                </div>
              </Col>
            }
          </Row>
        </Sidebar>
        <div className={"cp-visitor-hover-image"} style={{display:"none"}}>
          <img src={""} alt={"hover-img"} id={"hover-fr-img"}/>
        </div>
      </div>
    );
  }
}

const videoConstraints = {
  facingMode: "user"
};

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
  visitorList: state.receptSocketReducer.visitorList,
  userId: state.receptSocketReducer.userId,
  date: state.receptSocketReducer.date,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // delete visitors (socket)
    socketDeleteIdListHandler: (data) => dispatch(actionCreator.socketDeleteIdListHandler(data)),
    // add new visitor to queue (socket)
    socketAddNewBranchVisitorHandler: (data) => dispatch(actionCreator.socketAddNewBranchVisitorHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App));
